import { motion } from 'motion/react'
import Link from 'next/link'

import { extractFirstImageSource } from '@portal/news-lib/extract-image'

import placeholderImage from '@/shared/assets/placeholder.png'
import starIcon from '@/shared/assets/star.svg'
import { getPostLink } from '@/shared/lib/post-link'
import type { PostFeatured } from '@/shared/newsdb'

import styles from './view.module.css'

type SidebarPostProps = {
    post: PostFeatured
}

export function SidebarPost({ post }: SidebarPostProps) {
    const href = getPostLink({ label: post.label, slug: post.slug })
    const src = extractFirstImageSource(post.content)

    return (
        <div className={styles.post}>
            <motion.div whileHover={{ scale: 1.05 }} className={styles.postImageContainer}>
                <img src={starIcon.src} height={50} width={50} alt="star" className={styles.star} />
                <Link href={href} target="_blank" prefetch={false}>
                    <img src={src ?? placeholderImage.src} alt={post.title} className={styles.postImage} />
                </Link>
            </motion.div>

            <h2 className={styles.titleHeading}>
                <Link href={href} target="_blank" prefetch={false} className={styles.titleLink}>
                    {post.title}
                </Link>
            </h2>
        </div>
    )
}
